import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { CTAButton } from '../CTAButton';
import { deliverables } from '../../data/content';
export function Deliverables() {
  return <section className="w-full bg-white px-4 py-14 sm:px-6 sm:py-20" data-id="element-138" data-mp="me0c76d12itg">
      <div className="mx-auto max-w-4xl" data-id="element-139" data-mp="mbnnmacrla7f">
        <SectionHeading eyebrow="Instant delivery" title="What will you receive immediately after your purchase?" subtitle="From the first minute, you’ll have a complete clinical decision system ready for your next renal consultation." data-id="element-140" data-mp="qek9c9xlpmfl" />

        <ul className="mt-9 grid grid-cols-1 gap-4 sm:mt-12 lg:grid-cols-2 lg:gap-5" data-id="element-141" data-mp="154i1f0yniwa2">
          {deliverables.map((item, index) => <li key={item.title} className={`flex h-full flex-col rounded-3xl border border-navy-100 bg-cream p-5 sm:p-6 ${index === 0 ? 'lg:col-span-2 lg:bg-navy-900 lg:border-navy-900' : ''}`} data-id="element-142" data-mp="1a29pfjw6dy8z" data-mpi={index}>
              <span className="text-2xl" aria-hidden="true" data-id="element-143" data-mp="edwi5yvb7gwt">
                {item.emoji}
              </span>
              <h3 className={`mt-3 font-display text-[20px] font-bold leading-snug sm:text-[23px] ${index === 0 ? 'text-navy-900 lg:text-white' : 'text-navy-900'}`} data-id="element-144" data-mp="9fuvz52l71h4">
                {item.title}
              </h3>
              <div className="mt-2.5 space-y-2.5" data-id="element-145" data-mp="xcqtsyzh818r">
                {item.lines.map(line => <p key={line} className={`text-[14px] font-medium leading-relaxed sm:text-[15px] ${index === 0 ? 'text-navy-600 lg:text-navy-100' : 'text-navy-600'}`} data-id="element-146" data-mp="se75wt1bofdr">
                    {line}
                  </p>)}
              </div>
            </li>)}
        </ul>

        <p className="mx-auto mt-10 max-w-xl text-balance text-center font-display text-[21px] font-bold leading-snug text-navy-900 sm:mt-12 sm:text-2xl" data-id="element-147" data-mp="1c26hg63pnqk8">
          Any patient with kidney disease who walks into your office now has a clear clinical route.
        </p>

        <div className="mt-7 sm:mt-9" data-id="element-148" data-mp="1o23gpkei16f2">
          <CTAButton label="I want my clinical decision system" subline="Algorithms, protocols, clinical routes and checklists — all in one place." data-id="element-149" data-mp="1t2r3tuzlx340" />
        </div>
      </div>
    </section>;
}